const FOCUSABLE_SELECTOR =
    'input:not([type="hidden"]):not([disabled]), textarea, select, button:not([disabled])';

/**
 * Scrolls to and focuses the first field that has a validation error.
 * @param {Record<string, string>} errors - Validation errors keyed by field name
 * @param {string[]} fieldOrder - Field names in top-to-bottom display order
 */
export function focusFirstInvalidField(errors, fieldOrder) {
    if (!errors || Object.keys(errors).length === 0) return;

    const firstField = fieldOrder.find((field) => errors[field]);
    if (!firstField) return;

    const element =
        document.getElementById(firstField) ||
        document.querySelector(`[name="${firstField}"]`);

    if (!element) return;

    const scrollTarget =
        element.closest('[class*="mb-"]') || element.closest('.form-group') || element;

    scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });

    const focusable = element.matches(FOCUSABLE_SELECTOR)
        ? element
        : element.querySelector(FOCUSABLE_SELECTOR);

    if (focusable) {
        focusable.focus({ preventScroll: true });
    } else {
        element.setAttribute('tabindex', '-1');
        element.focus({ preventScroll: true });
    }
}
